export const CHANGE_CATEGORY = "CHANGE_CATEGORY";
export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";

export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";

export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";